// extracted by mini-css-extract-plugin
export default {"burger":"btUA6FL","icon":"BKBoO9a TYb4J9A c_IO2I_","burger__hidden":"GsizLQo"};